import { Component, OnInit, OnChanges, SimpleChanges, Input } from "@angular/core";
import { ChartOptions, ChartType, ChartDataSets } from "chart.js";
import { Label, ThemeService } from "ng2-charts";
import { GraphicData } from "../../schema/graphic-data";

@Component({
    selector: "app-graphic-bar",
    templateUrl: "./graphic-bar.component.html",
    styleUrls: ["./graphic-bar.component.scss"]
})
export class GraphicBarComponent implements OnInit, OnChanges {
    @Input("data")
    public data: GraphicData;

    public barChartLabels: Label[];
    public barChartData: ChartDataSets[];
    public barChartType: ChartType;
    public barChartLegend: boolean;
    public barChartPlugins: any[];
    public barChartOptions: ChartOptions;

    constructor() {
        this.barChartLabels = [];
        this.barChartData = [];
        this.barChartPlugins = [];
        this.barChartType = "bar";
        this.barChartLegend = true;

        this.barChartOptions = {
            responsive: true,
            legend: {
                labels: {
                    fontSize: 8
                }
            },
            scales: {
                yAxes: [
                    {
                        ticks: {
                            fontSize: 8,
                            stepSize: 1,
                            suggestedMin: 0
                        }
                    }
                ]
            }
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && JSON.stringify(changes.data.previousValue) != JSON.stringify(changes.data.currentValue)) {
            this.manageData(changes.data.currentValue);
        }
    }

    ngOnInit() {
        this.manageData(this.data);
    }

    private manageData(data: GraphicData) {
        this.barChartLabels = [];
        this.barChartData = [];

        if (data == undefined) return;

        if (data.keys.length <= 0) return;

        this.barChartLabels = data.keys;

        data.group.forEach((group) => {
            this.barChartData.push({
                data: group.values,
                label: group.group
            });
        });
    }
}
